import { Form } from 'antd';
import NepaliDatePickerComponent, { NepaliDatepickerProps } from './component';

/**
 * @deprecated Use NewNepaliDatePicker instead.
 */
export const NepaliDatePicker: React.FC<NepaliDatepickerProps> = (props) => {
  return <NepaliDatePickerComponent {...props} />;
};

interface NewNepaliDatePickerProps extends NepaliDatepickerProps {
  formProps: object;
  prefixName?: string;
  showTime?: any;
  selectRef?: any;
  form?: any;
}

export const NewNepaliDatePicker: React.FC<NewNepaliDatePickerProps> = (
  props,
) => {
  const { formProps, ...rest } = props;
  return (
    <Form.Item {...formProps} className="username">
      <NepaliDatePickerComponent {...rest} />
    </Form.Item>
  );
};
